import { twMerge } from "tailwind-merge";
import { Button, ButtonPropTypes } from "./Button";
// import { useTheme } from "context/ThemeContext";

const TertiaryButton = ({ className = "", style = {}, ...props }) => {
  //   const { theme } = useTheme();
  const cls = twMerge(
    `bg-white border border-Dark-Grey text-Very-Light-Gray 
      hover:shadow-md hover:text-red-600 hover:bg-Very-Light-Gray transition-shadow`,
    className
  );
  const st = {
    ...style,
    color: "#4E4E4E",
    borderColor: "#CACACA",
  };
  return <Button {...props} className={cls} style={st} />;
};
TertiaryButton.propTypes = ButtonPropTypes;

export default TertiaryButton;
